export default subjects => {
  return subjects.map(subject => {
    return {
      label: subject.detail.label,
      options: subject.children
        ? subject.children.map(child => ({
            id: child.id,
            label: child.detail.label,
            value: child.email
          }))
        : [
            {
              id: subject.id,
              label: subject.detail.label
            }
          ]
    };
  });
};
